import { Component, Input, OnInit } from '@angular/core';
import { currency } from 'app/constants/currency.constants';

import { DialogService } from 'primeng/dynamicdialog';
import { DataService, HelperService } from 'app/services';

import { CustomFleetPricingComponent } from '../../custom-fleet-pricing/custom-fleet-pricing/custom-fleet-pricing.component';
import { calculationTypes } from 'app/constants/customer';

@Component({
  selector: 'app-fleet-customer',
  templateUrl: './fleet-customer.component.html',
  styleUrls: ['./fleet-customer.component.scss'],
})
export class FleetCustomerComponent implements OnInit {
  @Input('user')
  set setUser(user: any) {
    this.customer = this.helperService.deepCopy(user);

    if (this.customer?.isMFCustomer && this.customer?.openFromMFC) {
      this.setFleetSettings();
    }
  }
  calculationTypes = calculationTypes;
  usd: string = currency.USD;
  customer: any = {};
  isFleetTaxOverRideEnabled: boolean;
  isAttributeBasedPricingEnable: boolean = false;

  constructor(private helperService: HelperService, private dialogService: DialogService, private dataService: DataService) { }

  ngOnInit() {
    this.isFleetTaxOverRideEnabled = this.dataService.isFleetTaxOverRideEnabled;
    this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
  }

  openFleetPricingModal() {
    const ref = this.dialogService.open(CustomFleetPricingComponent, {
      styleClass: 'add-dialog mkt-fleet-pricing-dialog',
      showHeader: false,
      data: this.customer,
    });

    const onClose = ref.onClose.subscribe((customer) => {
      if (customer && customer._id) {
        this.customer = customer;
      }

      onClose.unsubscribe();
    });
  };


  setFleetSettings() {
    if (!this.customer._id) return;

    this.customer = {
      ...this.customer,
      isOrderDiscOverride: this.customer.isOrderDiscOverride,
      isShopSuppliesOverride: this.customer.isShopSuppliesOverride,
      isLaborRateOverride: this.customer.isLaborRateOverride,
      isPricingMatrixOverride: this.customer.isPricingMatrixOverride,
      isPartPricingMatrixOverride: this.customer.isPartPricingMatrixOverride,
      isTirePricingMatrixOverride: this.customer.isTirePricingMatrixOverride,

      isTaxCodeOverride: this.customer.isTaxCodeOverride,
    };
    const { customLaborRate, customPartPricingMatrix,
      customTaxCode, customOrderDiscountType, customOrderDiscountValue, customOrderDiscountCap,
      customShopSuppliesType, customShopSuppliesValue, customShopSuppliesCap
    } = this.customer?.MFC?.fleetSettings;

    this.customer.customLaborRate = customLaborRate;
    this.customer.customPartPricingMatrix = customPartPricingMatrix;

    this.customer.customOrderDiscount = {
      value: customOrderDiscountValue,
      type: customOrderDiscountType?.value,
      cap: customOrderDiscountCap
    }

    this.customer.customShopSupplies = {
      value: customShopSuppliesValue,
      type: customShopSuppliesType?.value,
      cap: customShopSuppliesCap
    }

    this.customer.customTaxCode = customTaxCode;
  }

}
